export { default as Figure } from './Figure'
